import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { Symptom } from "src/app/core/model/v2/practitioner/symptom";
import { PractitionerSymptomsUpdate } from '../../../core/model/v2/practitioner/practitioner-symptoms-update';
import { WindowLoaderService } from '../window-loader/window-loader.service';
import { PractitionerSymptom } from '../../../core/model/v2/practitioner/practitioner-symptom';
import { BehaviorSubject, concat, Observable, of, Subject } from 'rxjs';
import {
  map,
  debounceTime,
  distinctUntilChanged,
  tap,
  switchMap,
  catchError,
  filter,
  takeUntil,
  startWith,
} from "rxjs/operators";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Practitioner } from '../../../core/model/v2/practitioner/practitioner';
import { MatCheckboxChange } from '@angular/material';
import { PractitionerCondition } from '../../../core/model/v2/practitioner/practitioner-condition';
import { Condition } from '../../../core/model/v2/practitioner/condition';
import { debug } from 'util';
import { PractitionerConditionsUpdate } from '../../../core/model/v2/practitioner/practitioner-conditions-update';
import { ActivatedRoute, Router } from '@angular/router';
import { sl } from 'date-fns/locale';
import { ViewChild } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-conditions',
  templateUrl: './conditions.component.html',
  styleUrls: ['./conditions.component.scss']
})
export class ConditionsComponent implements OnInit {
  @Input() practitionerId;
  @ViewChild('manualDiv', { static: false }) manualDiv: ElementRef<HTMLElement>;
  @ViewChild('myDiv', { static: false }) myDiv: ElementRef<HTMLElement>;
  isEditPractitionerCondition: boolean = false;
  isEditCondition: boolean = false;
  addNewModalTitle: string = "Add New Condition";
  addNewModalButtonText: string = "Add Condition";
  indexer: number;
  SymptomData: Practitioner = new Practitioner();
  //@Input() SymptomData: Practitioner = new Practitioner();
  centralList = [];
  private _snackBar: any;
  IsChecked: boolean = true;
  editProviderForm: FormGroup;
  editConditionForm: FormGroup;
  modelFormGroup: FormGroup;
  showManage: boolean = false;
  showMedicalManage: boolean = false;
  practitionerCondition: PractitionerCondition[] = [];
  behavioral = new BehaviorSubject<PractitionerCondition[]>([]);
  medical = new BehaviorSubject<PractitionerCondition[]>([]);
  conditionsList = new BehaviorSubject<Condition[]>([]);
  conditionsListData: Condition[] = [];
  behavioralList: PractitionerCondition[] = [];
  medicalList: PractitionerCondition[] = [];
  conditionName = new FormControl();
  conditionDescription = new FormControl();
  selectedTab: string = "Behavioral Health";
  selectedTabFullName: string = "Behavioral Health";
  patientId: number;
  isPractitioner: boolean=true;
  selectedConditions: number[] = [];
  conditionformControl = new FormControl();
  affilicationCtrl = new FormControl();
  modelFormCtrl = new FormControl();
  filteredAffiliations: Observable<PractitionerCondition[]>;
  filteredConditions: Observable<Condition[]>;

  constructor(private _practiceService: PracticeService,
    private _loaderService: WindowLoaderService,
    private fb: FormBuilder, private activatedRoute: ActivatedRoute,
    private router: Router,) {

  }

  ngOnInit(): void {
    this.getParams();
    if (this.patientId > 0) {
      this.showManage = false;
      this.isPractitioner = false;
    }
    this.getConditionsByPid(this.practitionerId);
    this.editConditionForm = new FormGroup({
      affilicationCtrl: new FormControl()
    });
    this.modelFormGroup = new FormGroup({
      modelFormCtrl: new FormControl()
    });
    this.router.navigate(
      [],
      {
        relativeTo: this.activatedRoute,
        queryParams: { section: 'condition' + this.practitionerId },
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
    
     this.getDetailsById(this.practitionerId);
     
    this.getAllConditions();

    this.filteredAffiliations = this.affilicationCtrl.valueChanges.pipe(
      startWith(""),
      debounceTime(400),
      map(val => {
        return this._filterAffilications(val || "");
      })
    );
    this.filteredConditions = this.modelFormCtrl.valueChanges.pipe(
      startWith(""),
      debounceTime(400),
      map(val => {
        return this._filterConditions(val || "");
      })
    );
    //this.loadsymptom();
  }
  getParams() {
    this.activatedRoute.params.subscribe(
      (params) => {
        this.patientId = params["patientId"];
      },
      (error) => {
        console.error(error);
      }
    );
  }
  showManageTab() {
    this.showManage = true;
  }
  showMedicalManageTab() {
    this.showMedicalManage = true;
  }
  enableEdit() {
    this.isEditPractitionerCondition = !this.isEditPractitionerCondition;
  }
  onChangeCheck(chk: MatCheckboxChange, symptom: Symptom) {

    if (!chk.checked) {
      this.deleteSymptom(symptom);
    }

  }
  onChangeCheckCondition(chk: MatCheckboxChange, symptom: Symptom) {

    if (chk.checked) {
      this.conditionsList.value.forEach(x => {
        x.isSelected = true;
       
      })
      this.conditionsList.value.forEach(x => {
        if (this.selectedConditions == undefined) {
          this.selectedConditions = [];
        }
        this.selectedConditions.push(x.id);
      })
    }
    else {
      this.conditionsList.value.forEach(x => {
        x.isSelected = false;
      });
      this.getAllConditions();
    }
    
  }
  formbuilding() {
    this.editProviderForm = this.fb.group({
      symptomFormControl: new FormControl(
        null,
        []
      ),
    });
    this.modelFormGroup = this.fb.group({
      modelFormCtrl: new FormControl(
        null,
        []
      ),
    });
  }
  onSubmitConditions() {
    const symptomUpdate = new PractitionerSymptomsUpdate();
    symptomUpdate.practitionerId = this.SymptomData.id;
    symptomUpdate.symptomIds = [];
    this.SymptomData.practitionerSymptoms.forEach((x) => {
      symptomUpdate.symptomIds.push(x.symptomId);
    });
    this._loaderService.show();
    this._practiceService.addOrUpdateSymptoms(symptomUpdate).subscribe(
      (res) => {
        // this._snackBar.open(
        //   `Treatment added to ${this.practitionerData.fullName}.`,
        //   "Ok"
        // );
        this._loaderService.hide();
      },
      (error) => {
        console.error(error);
        this._loaderService.hide();
      }
    );

  }

  /// Symptoms
  ////
  selectedSymptoms: Symptom[] = <any>[];
  symptomLoading = false;

  symptomInput$ = new Subject<string>();
  searchResultSymptoms: Observable<Symptom[]>;
  searchSymptom(term: string = null): Observable<Symptom[]> {
    return this._practiceService.getSymptomsByName(term);
  }
  trackSymptomByFn(item: Symptom) {
    return item.id;
  }

  loadsymptom() {
    this.searchResultSymptoms = concat(
      of([]), // default items
      this.symptomInput$.pipe(
        distinctUntilChanged(),
        filter((data) => data.trim().length > 2),
        debounceTime(500),
        tap(() => (this.symptomLoading = true)),
        switchMap((term) =>
          this._practiceService.getSymptomsByName(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.symptomLoading = false))
          )
        )
      )
    );
    this.searchResultSymptoms.subscribe((result) => {
      this.centralList = result;
    });
  }

  ////

  // onSymptomDelete(symptom): void {
  //   this._loaderService.show();
  //   this._practiceService.deletePractitionerSymptom(symptom.id).subscribe(
  //     (_) => {
  //       this.practitionerData.practitionerSymptoms =
  //         this.practitionerData.practitionerSymptoms.filter(
  //           (i) => i.symptom.name !== symptom.name
  //         );
  //       this._loaderService.hide();
  //     },
  //     (error) => {
  //       console.error(error);
  //       this._loaderService.hide();
  //     },
  //     () => {
  //       this._loaderService.hide();
  //     }
  //   );
  // }

  onSelectSymptom(symptom: Symptom): void {

    //console.log(symptom);
    if (!symptom.id) {
      this._practiceService.addnewSymptom(symptom.name).subscribe(
        (trt) => {
          this._loaderService.hide();
          if (trt) {
            if (trt.resultStatus.isSuccess) {
              //console.log(trt.result);
              symptom = trt.result;
              if (symptom.id) {
                const practitionerSymptom = new PractitionerSymptom();
                practitionerSymptom.practitioner = this.SymptomData;
                practitionerSymptom.practitionerId = this.SymptomData.id;
                practitionerSymptom.symptom = symptom;
                practitionerSymptom.symptomId = symptom.id;
                if (
                  this.SymptomData.practitionerSymptoms.find(
                    (x) => x.symptom.name == symptom.name
                  ) == null
                ) {
                  this.SymptomData.practitionerSymptoms.push(
                    practitionerSymptom
                  );
                } else {
                  // this._snackBar.open(
                  //   `Already existed to ${this.practitionerData.fullName}.`,
                  //   "Ok"
                  // );
                  this._loaderService.hide();
                }
              }
              //this.onSelectSymptom(trt.result);
            }
            //this.symptomsOptions = symp;
          }
        },
        (error) => {
          console.error(error);
          this._loaderService.hide();
          return null;
        }
      );
    }
    if (symptom.id) {
      const practitionerSymptom = new PractitionerSymptom();
      practitionerSymptom.practitioner = this.SymptomData;
      practitionerSymptom.practitionerId = this.SymptomData.id;
      practitionerSymptom.symptom = symptom;
      practitionerSymptom.symptomId = symptom.id;
      if (
        this.SymptomData.practitionerSymptoms.find(
          (x) => x.symptom.name == symptom.name
        ) == null
      ) {
        this.SymptomData.practitionerSymptoms.push(practitionerSymptom);
      } else {
        this._snackBar.open(
          `Already existed to ${this.SymptomData.fullName}.`,
          "Ok"
        );
        this._loaderService.hide();
      }
    }
  }
  deleteSymptom(item: any) {

    this.SymptomData.practitionerSymptoms =
      this.SymptomData.practitionerSymptoms.filter(
        (i) => i.symptom.name !== item.symptom.name
      );
  }
  OnProviderEditSubmit(editPForm: FormGroup) {

    var id = this.SymptomData.id;
    const symptomUpdate = new PractitionerSymptomsUpdate();
    symptomUpdate.practitionerId = this.SymptomData.id;
    symptomUpdate.symptomIds = [];
    this.SymptomData.practitionerSymptoms.forEach((x) => {
      symptomUpdate.symptomIds.push(x.symptomId);
    });
    this._loaderService.show();
    this._practiceService.addOrUpdateSymptoms(symptomUpdate).subscribe(
      (res) => {
        // this._snackBar.open(
        //   `Treatment added to ${this.practitionerData.fullName}.`,
        //   "Ok"
        // );
        this._loaderService.hide();
      },
      (error) => {
        console.error(error);
        this._loaderService.hide();
      }
    );
    this.centralList = [];
    this.isEditPractitionerCondition = false;
  }


   getConditionsByPid(practitionerId: number) {
    
    //var self = this;
     this._loaderService.show();
     this._practiceService.getPractitionerConditionsByPractitionerId(practitionerId).subscribe(
       (practitionerData) => {
         this.behavioral.next(practitionerData.filter(x => x.condition.conditionType.toLowerCase() == "behavioral"));
         this.behavioralList = practitionerData.filter(x => x.condition.conditionType.toLowerCase() == "behavioral");
         this.practitionerCondition = practitionerData;
         this.medical.next(practitionerData.filter(x => x.condition.conditionType.toLowerCase() == "medical"));
         this.medicalList = this.practitionerCondition.filter(x => x.condition.conditionType.toLowerCase() == "medical");
      },
      (error) => {
        console.error(error);
        this._loaderService.hide();
      },
      () => {
        this._loaderService.hide();
      }
    );

  }

  editConditionBehavioral(i: number) {

    this.indexer = i;
    this.isEditCondition = true;
    this.addNewModalTitle = "Update Condition";
    this.addNewModalButtonText = "Update Condition";
    this.conditionName.setValue(this.behavioral.value[i].condition.name);
    this.conditionDescription.setValue(this.behavioral.value[i].condition.description);

  }

  editConditionMedical(i: number) {

    this.indexer = i;
    this.isEditCondition = true;
    this.addNewModalTitle = "Update Condition";
    this.addNewModalButtonText = "Update Condition";
    this.conditionName.setValue(this.medical.value[i].condition.name);
    this.conditionDescription.setValue(this.medical.value[i].condition.description);

  }
  addCondition() {
    
    let condition = new Condition();
    condition.id = 0;
    condition.name = this.conditionName.value;
    condition.description = this.conditionDescription.value;
    condition.conditionType = this.getSelectedTabShortName(this.selectedTab);
    condition.isManual = true;
    condition.active = true;
    var self = this;
    self._loaderService.show();

    self._practiceService.addnewCondition(condition).subscribe(
      (conditionData) => {
        
        let pConditions = new PractitionerConditionsUpdate();
        pConditions.practitionerId = self.practitionerId;
        if (conditionData != undefined) {
          if (self.selectedConditions.indexOf(conditionData.result.id) == -1) {
            self.selectedConditions.push(conditionData.result.id);
          }
          pConditions.conditionIds = self.selectedConditions;
          self.addorUpdatePractitonerConditions(pConditions);
          self.conditionName.setValue("");
          self.conditionDescription.setValue("");
        }

      },
      (error) => {
        console.error(error);
        self._loaderService.hide();
      },
      () => {
        self._loaderService.hide();
      }
    );
    let el: HTMLElement = this.manualDiv.nativeElement;
    el.click();
  }
  updateCondition(i: number) {
    
    let condition = new Condition();
    condition.id = this.selectedTab != "Medical" ? this.behavioral.value[i].condition.id : this.medical.value[i].condition.id;
    condition.name = this.conditionName.value;
    condition.description = this.conditionDescription.value;
    condition.conditionType = this.selectedTab != "Medical" ? this.behavioral.value[i].condition.conditionType : this.medical[i].condition.conditionType;
    condition.isManual = this.selectedTab != "Medical" ? this.behavioral.value[i].condition.isManual : this.medical[i].condition.isManual;
    condition.active = this.selectedTab != "Medical" ? this.behavioral.value[i].condition.active : this.medical[i].condition.active;

    var self = this;
    self._loaderService.show();
    self._practiceService.updateCondition(condition).subscribe(
      (conditionData) => {
        
        this.getConditionsByPid(this.practitionerId);
      },
      (error) => {
        console.error(error);
        self._loaderService.hide();
      },
      () => {
        self._loaderService.hide();
      }
    );
    let el: HTMLElement = this.manualDiv.nativeElement;
    el.click();
  }
  conditionTabClick(tabName) {
    if (tabName.tab.textLabel.includes(this.selectedTab) == false) {
      this.selectedTab = tabName.tab.textLabel;

      this.selectedConditions = [];
      this.getConditionsByPid(this.practitionerId);;
      this.getAllConditions();
    }

  }
  deleteCondition(i: number) {

    if (i == undefined && this.behavioral.value.length < i) {
      return false;
    }
    this._loaderService.show();
    let pconditionid = this.selectedTab != "Medical" ? this.behavioral.value[i].id : this.medical.value[i].id;
   
    this._practiceService.deletePractitionerCondition(pconditionid).subscribe(
      (conditionData) => {
        
        if (conditionData.isSuccess) {
          this._loaderService.hide();
          this.ngOnInit();
          //this.getConditionsByPid(this.practitionerId);
        }
      },
      (error) => {
        console.error(error);
        this._loaderService.hide();
      },
      () => {
        this._loaderService.hide();
      }
    );
    

  }
  addorUpdatePractitonerConditions(pcondition: PractitionerConditionsUpdate) {
    this._loaderService.show();
    pcondition.conditionType = this.getSelectedTabShortName(this.selectedTab);
    this._practiceService.addOrUpdateConditions(pcondition).subscribe(
      (res) => {
        this._loaderService.hide();
        this.getConditionsByPid(this.practitionerId);
      },
      (error) => {
        console.error(error);
        this._loaderService.hide();
      },
      () => {
        this._loaderService.hide();
      }
    );
  }
  getAllConditions() {
    var self = this;
    self._loaderService.show();
    let tabName = self.getSelectedTabShortName(self.selectedTab);
    self._practiceService.getConditions(tabName).subscribe(
      (conditionList) => {
        self.conditionsList.next(conditionList);
        if (self.practitionerCondition != undefined && conditionList != undefined && conditionList != null && conditionList.length > 0) {
          self.practitionerCondition.forEach(x => {
            let p = conditionList.find(y => y.id == x.condition.id);
            if (conditionList[conditionList.indexOf(p)] != undefined) {
              conditionList[conditionList.indexOf(p)].isSelected = true;
            }
          });
          
          let sConditions = conditionList.filter(x => x.isSelected == true);
          if (sConditions.length > 0) {
            self.selectedConditions = [];
          }
          sConditions.forEach(x => {
            /*if (self.selectedConditions.indexOf(x.id) == -1) {*/
              
              self.selectedConditions.push(x.id);
            /*}*/
          });
        }

      //  self.conditionsList = conditionList;
        self.conditionsListData = conditionList;
      },
      (error) => {
        console.error(error);
        self._loaderService.hide();
      },
      () => {
        self._loaderService.hide();
      }
    );
  }
  addSelectedConditions() {
    var self = this;    
    let pCon = new PractitionerConditionsUpdate();
    pCon.practitionerId = this.practitionerId;
    self.selectedConditions.forEach(x => {
      pCon.conditionIds.push(x);
    });
    pCon.conditionType = self.getSelectedTabShortName(self.selectedTab);
    self._loaderService.show();
    self._practiceService.addOrUpdateConditions(pCon).subscribe(
      (conditionData) => {
        
        self.getConditionsByPid(self.practitionerId);
      },
      (error) => {
        console.error(error);
        self._loaderService.hide();
      },
      () => {
        self._loaderService.hide();
      }
    );
    
    let el: HTMLElement = this.myDiv.nativeElement;
    el.click();
  }
  updateConditionList(condition: Condition) {

    if (!this.selectedConditions)
      this.selectedConditions = [];

    if (condition.isSelected) {
      if (this.selectedConditions.indexOf(condition.id) == -1) {
        this.selectedConditions.push(condition.id);
      }

    } else {
      this.selectedConditions = this.selectedConditions.filter(ph => ph != condition.id);
    }

  }
  getDetailsById(practitionerId: number) {
    let that = this;
    that._loaderService.show();
    that._practiceService.getPractitionerDetails(practitionerId).subscribe(
      (practitionerData) => {
        
        that.SymptomData = practitionerData;
        that.formbuilding();
      },
      (error) => {
        console.error(error);
        that._loaderService.hide();
      },
      () => {
        that._loaderService.hide();
      }
    );

  }
  getSelectedTabShortName(selectedTab) {
    return (selectedTab == "" || selectedTab == undefined) ? "Behavioral" : selectedTab == "Behavioral Health" ? "Behavioral" : "Medical";
  }
  _filterAffilications(value: string) {
    
    let result: PractitionerCondition[];
    if (value.length >= 2) {
      if (this.getSelectedTabShortName(this.selectedTab) == "Medical") {
        result = this.medicalList.filter((x) => x.condition.name.startsWith(value));
        this.medical.next(result);
      }
      else {
        result = this.behavioralList.filter((x) => x.condition.name.startsWith(value));
        this.behavioral.next(result);
      }
    }
    else {
      
      if (this.getSelectedTabShortName(this.selectedTab) == "Medical") {
        this.medical.next(this.medicalList);
      }
      else {
        this.behavioral.next(this.behavioralList);
      }
    }
    return result;
  }
  _filterConditions(value: string) {
    
    if (value.length >= 2) {
      let p1 = this.conditionsListData.filter((x) => x.name.startsWith(value));
      this.conditionsList.next(p1);
      return p1;
    }
    else {
      this.conditionsList.next(this.conditionsListData);
    }

  }

}
